import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { DocumentData } from 'firebase/firestore'
import { format } from 'date-fns'
import styled from '@emotion/styled'

type Props = {
  search: DocumentData
}

export const Search = ({ search }: Props) => {
  const [isHovered, setIsHovered] = useState(false)
  const navigate = useNavigate()

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const formattedDate = isFinite(+new Date(search.createdAt))
    ? format(new Date(search.createdAt), 'MMMM do yyyy h:mma')
    : null

  const handleSearchClick = () => {
    navigate(`/searches/${search.id}`)
  }

  return (
    <StyledCard
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      variant={isHovered ? 'elevated' : 'outline'}
      onClick={handleSearchClick}
    >
      <CardHeader>
        <Heading noOfLines={2} size='md'>
          {search.description}
        </Heading>
      </CardHeader>
      {formattedDate ? (
        <CardBody>
          <Text>{formattedDate}</Text>
        </CardBody>
      ) : null}
    </StyledCard>
  )
}

const StyledCard = styled(Card)`
  margin-bottom: 1rem;
  cursor: pointer;
`
